import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class FooterService {
  private rvw: BehaviorSubject<any>;
  public rvwInput = false;
  constructor() {
    this.rvw = new BehaviorSubject(false);
  }

  setReviewCtrl = (enable) => {
    this.rvwInput = enable;
    this.rvw.next(enable);
  }

  getReviewCtrl = (): Observable<any> => {
    return this.rvw.asObservable();
  }
}